import { Link } from "@tanstack/react-router";
import { Button } from "@sportsmet/ui";
import { useShellBadges } from "../../shell/useShellBadges";
export function PoolInvitationsLink() {
  const { inviteCount } = useShellBadges();
  return (
    <Button asChild variant="secondary">
      <Link to="/pools/invitations">
        Pool invitations{inviteCount > 0 ? ` (${inviteCount})` : ""}
      </Link>
    </Button>
  );
}
